<template>
    <div class="ep-table">
        <!-- Search -->
        <div class="row ep-table-search">
            <div class="col-lg-3 col-sm-4 col-xs-12" v-if="value !== null">
                <div class="form-group has-feedback">
                    <i class="fa fa-search form-control-feedback"></i>
                    <input
                        ref="searchListInput"
                        :value="value"
                        @input="$emit('input', $event.target.value)"
                        class="form-control"
                        type="text"
                        :placeholder="trans('app.search')"
                    />
                </div>
            </div>
            <slot name="after-search"></slot>
        </div>

        <!-- Header -->
        <div class="ep-table-header row" v-if="$slots.header">
            <div class="col-xs-12 space-y-6">
                <div class="relative client-row card-box">
                    <slot name="header"></slot>
                </div>
            </div>
        </div>

        <!-- List -->
        <div class="row ep-table-list">
            <div class="col-xs-12 space-y-6">
                <div
                    class="ep-table-row relative client-row card-box mb-0"
                    :class="{'hoverable cursor-pointer': hoverable}"
                    :style="{'background-color': backgroundColor}"
                    v-for="(item, index) in items"
                    :key="index"
                    @click="$emit('select', item)"
                >
                    <slot name="row" :row="item"></slot>
                </div>
            </div>

            <div class="col-xs-12">
                <slot name="no-results"></slot>
            </div>
        </div>

        <!-- Pagination -->
        <paginator
            v-if="hasPagination"
            v-model="paginator">
        </paginator>

    </div>
</template>

<script>
import Paginator from 'App/components/global/Paginator'

export default {
    components: {
        Paginator,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        items: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Object,
            required: false,
            default: () => {},
        },
        hoverable: {
            type: Boolean,
            required: false,
            default: true,
        },
        backgroundColor: {
            type: String,
            required: false,
            default: '',
        },
        limit: {
            type: Number,
            required: false,
            default: 10
        }
    },
    data () {
        return {
            paginator: this.pagination,
        }
    },
    computed: {
        hasPagination () {
            return Object.keys(this.pagination).length > 0 && this.pagination.hasOwnProperty('total') && this.pagination.total > this.limit
        }
    },
    watch: {
        'paginator.current_page': function (value) {
            this.$emit('page-changed', value)
        },
    }
}
</script>
